export function getErrorMessage(error: any) {
  if (error.response) {
    return error.response.data.message || error.response.data.detail[0].msg
  } else {
    return null
  }
}
